import React, { useState } from "react";
import Img1 from "../assets/images/dirigenti.webp";
import arrowIcon from "../assets/images/Vector_btn.png";
import { ReactComponent as QuoteOpen } from "../assets/images/quote-sx.svg";
import Sezione2popup1 from "./popup/en/en-sezione-2-popup-1";

const QuoteBlock = ({ children }) => (
  <div className="relative pl-10 pr-10 mb-8 text-[#0E3761] leading-relaxed">
    <QuoteOpen className="absolute left-0 top-0 w-8 h-8 text-[#0E3761]" />
    <p className="text-[20px] md:text-[22px]">{children}</p>

  </div>
);

export default function Sezione2EN() {

  const [open1, setOpen1] = useState(false);

  return (
    <>
    <div id="sezione-lettere" className="pt-8">

      <div className="w-full xl:w-[1440px] flex flex-col md:flex-row mx-auto  px-4 md:px-5 xl:px-0">
      {/* Colonna Sinistra */}
      <div className="flex justify-center items-end w-full md:w-1/2">
        <img className="w-[100%]" alt="Chairman and General Manager of Reale Group" src={Img1} />
      </div>

      {/* Colonna Destra */}
      <div className="flex items-start flex-col justify-center w-full md:w-1/2 py-6 px-6">
        <h2 className="mb-6 text-[#0E3761]">
          Letter to the Stakeholders
        </h2>

        <QuoteBlock>
          In 2025, Reale Group operated within a highly complex geopolitical
          and macroeconomic environment. Nevertheless, the Group demonstrated
          resilience and solidity, reaffirming that a business model grounded
          in mutuality and sustainability is capable of creating long-term
          value for its members and for the communities in which it operates.
        </QuoteBlock>

        <button
          className="bt-secondary flex items-center gap-2"
          onClick={() => setOpen1(true)}
          >
          <img src={arrowIcon} alt="Arrow" className="w-[25px] h-[25px]" />
          Read the letter
        </button>
      </div>

    </div>
    </div>

    {/* Popup lettera (unica, firmata da Presidente e General Manager) */}
    <Sezione2popup1 isOpen={open1} onClose={() => setOpen1(false)} />

    </>
  );
}
